import "./Partners.module.css";
import Header from "@/reusable_sections/Header";
import OurDonorEcosystem from "./sections/OurDonorEcosystem";
import SponsorshipOpportunities from "./sections/SponsorshipOpportunities";
import CorporatePartnershipInquiry from "./sections/CorporatePartnershipInquiry";
import Footer from "@/reusable_sections/Footer";
export default function PartnersPage() {
  return <div>
      <Header />
      <OurDonorEcosystem />
      <SponsorshipOpportunities />
      <CorporatePartnershipInquiry />
      <Footer />
    </div>;
}